// extracted by mini-css-extract-plugin
export var awardsDivider = "homePage-module--awardsDivider--iLJjR";
export var awardsToggleButton = "homePage-module--awardsToggleButton--m-qh+";
export var hiddenAwardsContainer = "homePage-module--hiddenAwardsContainer--lsVtQ";
export var homepageSection = "homePage-module--homepageSection--dp4tl";
export var interestsHeading = "homePage-module--interestsHeading--0pgd1";
export var listItem = "homePage-module--listItem--hnGwi";
export var newsContent = "homePage-module--newsContent--HDZ0r";
export var newsDate = "homePage-module--newsDate--S2X8j";
export var newsItem = "homePage-module--newsItem--UYvDa";
export var rsButton = "homePage-module--rs-button--iR-Ba";
export var timelineEnter = "homePage-module--timeline-enter--ZThil";
export var timelineLeave = "homePage-module--timeline-leave--Jig88";